var map = {
	"./DIGECO_03_03_01.svg": "./img/DIGECO_03_03_01.svg",
	"./DIGECO_03_03_02.svg": "./img/DIGECO_03_03_02.svg",
	"./DIGECO_03_03_03.svg": "./img/DIGECO_03_03_03.svg",
	"./EUMOVE_2_1_3_1.svg": "./img/EUMOVE_2_1_3_1.svg",
	"./EUMOVE_2_1_3_2.svg": "./img/EUMOVE_2_1_3_2.svg",
	"./EUMOVE_2_1_3_3.svg": "./img/EUMOVE_2_1_3_3.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./img sync recursive ^\\.\\/.*\\.svg$";